/* UBIYAM pop — motion helpers: scroll reveals, endless marquees, flipping words, topbar phases, product gallery, sticky add-to-cart, sort, share, editor hooks */
(function () {
  var root = document.documentElement;
  root.classList.add('pop-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.pop-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
      // fire a screenful early so a block has finished revealing by the time it
      // is actually looked at, instead of animating under the reader's eyes
    }, { rootMargin: '200px 0px 90% 0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Below-the-fold images stay lazy so they never compete with the first paint,
  // but the native threshold is tight enough that a section can still be caught
  // mid-load when it is scrolled to. Start them roughly two screens out instead,
  // which is early enough to be painted on arrival without pulling down a whole
  // long page for someone who never scrolls.
  var warmIO = null;
  function warmImages(scope) {
    if (!('IntersectionObserver' in window)) return;
    var found = (scope || document).querySelectorAll('img[loading="lazy"], iframe[loading="lazy"]');
    if (!found.length) return;
    if (!warmIO) {
      warmIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.loading = 'eager';
          warmIO.unobserve(entry.target);
        });
      }, { rootMargin: '1800px 0px 1800px 0px' });
    }
    [].forEach.call(found, function (el) {
      if (el.dataset.popWarm) return;
      el.dataset.popWarm = '1';
      warmIO.observe(el);
    });
  }

  // The native date control drops a browser calendar that cannot be themed, so
  // the field is a readonly text input and this draws the calendar instead. The
  // value stays YYYY-MM-DD, which is what Shopify wants for the Send on property.
  var POP_MON = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
                 'August', 'September', 'October', 'November', 'December'];
  var POP_DOW = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
  var POP_CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><rect x="3.2" y="5" width="17.6" height="16" rx="3"/><path d="M3.2 10h17.6M8 3v4M16 3v4"/></svg>';
  var POP_CHEVL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5.5 8.5 12l6.5 6.5"/></svg>';
  var POP_CHEVR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5.5 15.5 12 9 18.5"/></svg>';

  function popDates(scope) {
    var found = (scope || document).querySelectorAll('input[data-pop-date]');
    [].forEach.call(found, function (input) {
      if (input.dataset.popDateReady) return;
      input.dataset.popDateReady = '1';

      var field = input.closest('.field') || input.parentElement;
      if (!field) return;
      field.classList.add('pop-date');

      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
      var parse = function (v) {
        var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || '').trim());
        if (!m) return null;
        var d = new Date(+m[1], +m[2] - 1, +m[3]);
        d.setHours(0, 0, 0, 0);
        return isNaN(d.getTime()) ? null : d;
      };

      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var sel = parse(input.value);
      var view = new Date((sel || today).getFullYear(), (sel || today).getMonth(), 1);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pop-date__btn';
      btn.setAttribute('aria-label', 'Choose a date');
      btn.innerHTML = POP_CAL;
      field.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'pop-date__panel';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Choose a date');
      panel.hidden = true;
      field.appendChild(panel);

      function draw() {
        var y = view.getFullYear();
        var m = view.getMonth();
        var lead = (new Date(y, m, 1).getDay() + 6) % 7;
        var days = new Date(y, m + 1, 0).getDate();
        var h = '<div class="pop-date__head">'
          + '<button type="button" class="pop-date__nav" data-mv="-1" aria-label="Previous month">' + POP_CHEVL + '</button>'
          + '<span class="pop-date__title">' + POP_MON[m] + ' ' + y + '</span>'
          + '<button type="button" class="pop-date__nav" data-mv="1" aria-label="Next month">' + POP_CHEVR + '</button>'
          + '</div><div class="pop-date__dow" aria-hidden="true">';
        for (var i = 0; i < 7; i++) h += '<span>' + POP_DOW[i] + '</span>';
        h += '</div><div class="pop-date__grid">';
        for (var k = 0; k < lead; k++) h += '<span></span>';
        for (var d = 1; d <= days; d++) {
          var date = new Date(y, m, d);
          var cls = 'pop-date__day';
          if (sel && +sel === +date) cls += ' is-on';
          if (+today === +date) cls += ' is-today';
          h += '<button type="button" class="' + cls + '" data-d="' + iso(date) + '"'
            + (date < today ? ' disabled' : '')
            + (sel && +sel === +date ? ' aria-current="date"' : '') + '>' + d + '</button>';
        }
        h += '</div><div class="pop-date__foot">'
          + '<button type="button" class="pop-date__act" data-clear>Clear</button>'
          + '<button type="button" class="pop-date__act pop-date__act--go" data-today>Today</button>'
          + '</div>';
        panel.innerHTML = h;
      }

      function set(v) {
        input.value = v;
        sel = parse(v);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function place() {
        panel.classList.remove('pop-date__panel--up');
        var r = panel.getBoundingClientRect();
        if (r.bottom > (window.innerHeight || 0) - 8 && r.height < input.getBoundingClientRect().top) {
          panel.classList.add('pop-date__panel--up');
        }
      }

      function outside(e) { if (!field.contains(e.target)) close(); }
      function onKey(e) {
        if (e.key === 'Escape' || e.key === 'Esc') { close(); input.focus(); }
      }

      function open() {
        if (!panel.hidden) return;
        sel = parse(input.value);
        view = new Date((sel || today).getFullYear(), (sel || today).getMonth(), 1);
        draw();
        panel.hidden = false;
        field.classList.add('is-open');
        place();
        document.addEventListener('mousedown', outside, true);
        document.addEventListener('keydown', onKey, true);
      }
      var justClosed = false;
      function close() {
        if (panel.hidden) return;
        panel.hidden = true;
        field.classList.remove('is-open');
        document.removeEventListener('mousedown', outside, true);
        document.removeEventListener('keydown', onKey, true);
        // focus goes back to the input after a pick, and that would re-open it
        justClosed = true;
        window.setTimeout(function () { justClosed = false; }, 250);
      }

      panel.addEventListener('click', function (e) {
        var mv = e.target.closest('[data-mv]');
        if (mv) { view.setMonth(view.getMonth() + parseInt(mv.dataset.mv, 10)); draw(); return; }
        var day = e.target.closest('[data-d]');
        if (day && !day.disabled) { set(day.dataset.d); close(); input.focus(); return; }
        if (e.target.closest('[data-clear]')) { set(''); close(); input.focus(); return; }
        if (e.target.closest('[data-today]')) { set(iso(today)); close(); input.focus(); }
      });

      // one delegated handler on the field: a press that starts on the input and
      // ends on the button fires its click on their shared parent, so binding to
      // the button alone drops it
      field.addEventListener('click', function (e) {
        if (panel.contains(e.target)) return;
        if (e.target.closest && e.target.closest('.pop-date__btn')) {
          e.preventDefault();
          if (panel.hidden) open(); else close();
          return;
        }
        if (!justClosed) open();
      });
      input.addEventListener('focus', function () { if (!justClosed) open(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); open(); }
      });
    });
  }

  // Endless marquee
  function marquee(scope) {
    (scope || document).querySelectorAll('.pop-marquee').forEach(function (m) {
      var track = m.querySelector('.pop-marquee__track');
      if (!track || track.dataset.popReady) return;
      var base = track.innerHTML;
      var width = m.offsetWidth || window.innerWidth;
      var guard = 0;
      while (track.scrollWidth < width + 10 && guard < 10) {
        track.insertAdjacentHTML('beforeend', base);
        guard++;
      }
      track.insertAdjacentHTML('beforeend', track.innerHTML);
      track.dataset.popReady = '1';
    });
  }

  // Flipping word
  function flips(scope) {
    (scope || document).querySelectorAll('.pop-flip').forEach(function (f) {
      if (f.dataset.popReady) return;
      f.dataset.popReady = '1';
      var words = [].slice.call(f.children);
      if (words.length < 2) return;
      var i = 0;
      function next() {
        words[i].classList.remove('is-on');
        i = (i + 1) % words.length;
        words[i].classList.add('is-on');
      }
      function fit() {
        var w = words[i].getBoundingClientRect().width;
        if (w) f.style.setProperty('--flip-w', Math.ceil(w) + 'px');
      }
      var _next = next;
      next = function () { _next(); fit(); };
      fit();
      window.addEventListener('resize', fit);
      var timer = reduce ? null : setInterval(next, parseInt(f.dataset.every || '2400', 10));
      f.addEventListener('click', function () {
        next();
        if (timer) { clearInterval(timer); timer = setInterval(next, parseInt(f.dataset.every || '2400', 10)); }
      });
    });
  }

  // Topbar phases
  var topbar = {
    bar: null, hero: null, header: null, solid: false, ticking: false, on: false,
    init: function () {
      var bar = document.querySelector('.pop-topbar');
      var hero = document.querySelector('.pop-hero-full');
      var main = document.getElementById('MainContent');
      if (!bar || !main) return;
      var header = bar.querySelector('.section-header') || bar;
      root.style.setProperty('--pop-header-h', header.offsetHeight + 'px');
      if (!hero) return;
      var first = main.querySelector('.shopify-section');
      if (!first || !first.contains(hero)) return;
      this.bar = bar; this.hero = hero; this.header = header;
      if (!this.on) {
        this.on = true;
        root.classList.add('pop-nav-overlay');
        var self = this;
        window.addEventListener('scroll', function () {
          if (!self.ticking) { self.ticking = true; requestAnimationFrame(function () { self.update(); }); }
        }, { passive: true });
        window.addEventListener('resize', function () { self.measure(); self.update(); });
        window.addEventListener('load', function () { self.measure(); self.update(); });
      }
      this.measure();
      this.update();
    },
    measure: function () {
      root.style.setProperty('--pop-topbar-h', this.bar.offsetHeight + 'px');
      root.style.setProperty('--pop-header-h', this.header.offsetHeight + 'px');
    },
    update: function () {
      this.ticking = false;
      var limit = this.hero.offsetTop + this.hero.offsetHeight - this.header.offsetHeight;
      var solid = window.scrollY > limit;
      if (solid !== this.solid) {
        this.solid = solid;
        this.bar.classList.toggle('is-solid', solid);
        root.classList.toggle('pop-nav-solid', solid);
      }
    }
  };

  function hoverMenus() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      if (d.dataset.popHover) return;
      d.dataset.popHover = '1';
      var summary = d.querySelector('summary');
      var timer;
      function open() { clearTimeout(timer); if (!d.open) { d.open = true; if (summary) summary.setAttribute('aria-expanded', 'true'); } }
      function close() { clearTimeout(timer); timer = setTimeout(function () { d.open = false; if (summary) summary.setAttribute('aria-expanded', 'false'); }, 160); }
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', close);
    });
  }

  // Product gallery
  function galleries(scope) {
    (scope || document).querySelectorAll('pop-gallery').forEach(function (g) {
      if (g.dataset.popReady) return;
      g.dataset.popReady = '1';
      var slides = [].slice.call(g.querySelectorAll('.pop-gallery__slide'));
      var thumbs = [].slice.call(g.querySelectorAll('.pop-gallery__thumb'));
      var frame = g.querySelector('.pop-gallery__frame');
      function show(id) {
        var found = false;
        slides.forEach(function (s) { var on = s.dataset.mediaId === id; s.classList.toggle('is-on', on); if (on) found = true; });
        if (!found) return;
        thumbs.forEach(function (t) {
          var on = t.dataset.mediaId === id;
          t.classList.toggle('is-on', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) {} }
        });
      }
      function index() {
        for (var i = 0; i < slides.length; i++) { if (slides[i].classList.contains('is-on')) return i; }
        return 0;
      }
      function step(d) {
        if (slides.length < 2) return;
        show(slides[(index() + d + slides.length) % slides.length].dataset.mediaId);
      }
      var sp = null;
      var mountSplide = function () {
        if (sp || !window.Splide || !frame || slides.length < 2) return;
        if (!frame.hasAttribute('data-pop-galsplide')) return;
        sp = new Splide(frame, {
          type: 'loop',
          perPage: 1,
          arrows: false,
          pagination: false,
          drag: true,
          speed: reduce ? 0 : 420,
          easing: 'cubic-bezier(0.2, 0.7, 0.25, 1)'
        });
        sp.on('move', function (i) {
          var cur = slides[i];
          if (cur) show(cur.dataset.mediaId);
        });
        sp.on('moved', function () {
          var cur = slides[sp.index];
          if (cur) show(cur.dataset.mediaId);
        });
        var popTouched = false;
        root.addEventListener('pointerdown', function () { popTouched = true; }, { passive: true });
        var popSettle = function () {
          try {
            sp.refresh();
            if (!popTouched && sp.Components && sp.Components.Move && sp.Components.Move.jump) {
              sp.Components.Move.jump(0);
            }
          } catch (e) {}
        };
        if (document.readyState !== 'complete') {
          window.addEventListener('load', popSettle, { once: true });
        }
        window.setTimeout(popSettle, 450);
        window.setTimeout(popSettle, 1500);
        sp.mount();
      };
      // Slides past the first stay lazy through the initial load, so they never
      // compete with the LCP image. Once the page is idle they are pulled in the
      // background, so clicking a thumbnail shows a picture that is already there
      // instead of starting a download.
      function warmSlides() {
        var imgs = g.querySelectorAll('.pop-gallery__slide img[loading="lazy"], .pop-gallery__thumb img[loading="lazy"]');
        var i = 0;
        function nextOne() {
          if (i >= imgs.length) return;
          var img = imgs[i++];
          img.setAttribute('fetchpriority', 'low');
          img.loading = 'eager';
          // One at a time, each after the last settles, so the warm-up never
          // crowds out anything the visitor actually asked for.
          if (img.complete) nextOne();
          else {
            img.addEventListener('load', nextOne, { once: true });
            img.addEventListener('error', nextOne, { once: true });
          }
        }
        nextOne();
      }
      function idle(fn) {
        if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 3000 });
        else window.setTimeout(fn, 1200);
      }
      if (document.readyState === 'complete') idle(warmSlides);
      else window.addEventListener('load', function () { idle(warmSlides); }, { once: true });

      var galTries = 0;
      var waitSplide = function () {
        if (sp) return;
        if (window.Splide) { mountSplide(); return; }
        if (++galTries > 60) return;
        window.setTimeout(waitSplide, 300);
      };
      waitSplide();

      // A thumbnail is direct navigation, so it jumps: the slide transition is
      // suppressed for that one move and the selected state is painted in the
      // same frame as the click. Arrows and dragging keep the animation.
      function goTo(id, instant) {
        if (!sp) { show(id); return; }
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.mediaId !== id) continue;
          if (i === sp.index) { show(id); return; }
          show(id);
          // Controller.go runs the loop shift and a full relayout: about 270ms on a
          // throttled phone, before the 420ms slide even starts. Move.jump costs
          // half a millisecond, so a thumbnail lands on the frame it was clicked.
          var C = sp.Components;
          if (instant && C && C.Move && C.Move.jump && C.Controller && C.Controller.setIndex) {
            C.Controller.setIndex(i);
            C.Move.jump(i);
          } else {
            sp.go(i);
          }
          return;
        }
        show(id);
      }
      function move(d) {
        if (sp) { sp.go(d < 0 ? '<' : '>'); return; }
        step(d);
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.mediaId, true); }); });
      var prev = g.querySelector('.pop-gallery__nav--prev');
      var next = g.querySelector('.pop-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      if (frame) {
        frame.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') move(-1);
          if (e.key === 'ArrowRight') move(1);
        });
      }
      g.show = goTo;
      if (typeof window.subscribe === 'function') {
        window.subscribe('variant-change', function (e) {
          var v = e && e.data && e.data.variant;
          if (!v || e.data.sectionId !== g.dataset.section) return;
          if (v.featured_media && v.featured_media.id) goTo(String(v.featured_media.id));
        });
      }
    });
  }

  // Sticky add-to-cart bar
  function accordions(scope) {
    (scope || document).querySelectorAll('details.pop-faq__item').forEach(function (d) {
      if (d.dataset.popReady) return;
      d.dataset.popReady = '1';
      var summary = d.querySelector('summary');
      var body = d.querySelector('.pop-faq__a');
      if (!summary || !body) return;
      var busy = false;
      function slide(open, done) {
        if (reduce || !body.animate) { d.open = open; if (done) done(); return; }
        busy = true;
        if (open) d.open = true;
        body.style.overflow = 'hidden';
        body.style.boxSizing = 'border-box';
        var h = body.scrollHeight + 'px';
        var anim = body.animate(
          [{ height: open ? '0px' : h, opacity: open ? 0 : 1 }, { height: open ? h : '0px', opacity: open ? 1 : 0 }],
          { duration: 340, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' }
        );
        anim.onfinish = anim.oncancel = function () {
          body.style.overflow = '';
          body.style.boxSizing = '';
          if (!open) d.open = false;
          busy = false;
          if (done) done();
        };
      }
      d.addEventListener('pop:close', function () { if (d.open && !busy) slide(false); });
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (busy) return;
        if (d.open) { slide(false); return; }
        var group = d.parentElement;
        if (group) group.querySelectorAll('details.pop-faq__item[open]').forEach(function (o) { if (o !== d) o.dispatchEvent(new Event('pop:close')); });
        slide(true);
      });
    });
  }

  // Story timeline
  function story() {
    var lists = document.querySelectorAll('.pop-story__list');
    if (!lists.length) return;
    if (reduce) { lists.forEach(function (l) { l.style.setProperty('--story-p', 1); }); return; }
    function update() {
      document.querySelectorAll('.pop-story__list').forEach(function (list) {
        var r = list.getBoundingClientRect();
        var p = (window.innerHeight * 0.55 - r.top) / r.height;
        list.style.setProperty('--story-p', Math.max(0, Math.min(1, p)).toFixed(3));
      });
    }
    if (!story._bound) {
      story._bound = true;
      var tick = false;
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(function () { tick = false; update(); }); } }, { passive: true });
      window.addEventListener('resize', update);
    }
    update();
  }

  // Article page
  function articleLayout() {
    var body = document.querySelector('.pop-article__body');
    if (!body) return;

    body.querySelectorAll('table').forEach(function (t) {
      if (!t.closest('.pop-tablewrap')) {
        var w = document.createElement('div');
        w.className = 'pop-tablewrap';
        t.parentNode.insertBefore(w, t);
        w.appendChild(t);
      }
      var heads = [].slice.call(t.querySelectorAll('thead th')).map(function (th) {
        return (th.textContent || '').trim();
      });
      if (!heads.length) return;
      t.querySelectorAll('tbody tr').forEach(function (tr) {
        [].slice.call(tr.children).forEach(function (cell, i) {
          if (cell.tagName === 'TD' && !cell.hasAttribute('data-label')) {
            cell.setAttribute('data-label', heads[i] || '');
          }
        });
      });
    });

    // jump rail
    var railHost = document.querySelector('[data-pop-toc]');
    var heads = [].slice.call(body.querySelectorAll('h2')).filter(function (h) {
      return (h.textContent || '').trim().length > 1 && !h.closest('.pop-rc');
    });
    var links = [];
    if (railHost && heads.length >= 3) {
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'sec-' + (i + 1) + '-' + (h.textContent || '').trim().toLowerCase()
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
      });
      var list = heads.map(function (h) {
        return '<a href="#' + h.id + '">' + h.textContent.trim().replace(/[<>&]/g, '') + '</a>';
      }).join('');
      railHost.innerHTML =
        '<details class="pop-toc" data-pop-tocbox>' +
          '<summary>In this article</summary><div>' + list + '</div>' +
        '</details>';
      var box = railHost.querySelector('[data-pop-tocbox]');
      links = [].slice.call(railHost.querySelectorAll('a'));
      // wide screens
      var wide = window.matchMedia('(min-width: 1024px)');
      function syncToc() {
        if (wide.matches) { box.open = true; box.setAttribute('data-static', ''); }
        else { box.removeAttribute('data-static'); }
      }
      box.addEventListener('click', function (e) {
        if (wide.matches && e.target.closest('summary')) e.preventDefault();
      });
      (wide.addEventListener ? wide.addEventListener('change', syncToc) : wide.addListener(syncToc));
      syncToc();
      links.forEach(function (a) {
        a.addEventListener('click', function () { if (!wide.matches) box.open = false; });
      });
    }

    var target = document.querySelector('[data-pop-aside-target]');
    var asides = [].slice.call(body.querySelectorAll('.pop-aside'));
    if (target && asides.length) {
      asides.forEach(function (el, i) {
        var mark = document.createComment('pop-aside-' + i);
        el.parentNode.insertBefore(mark, el);
        el._popHome = mark;
      });
      var mq = window.matchMedia('(min-width: 1240px)');
      function place() {
        asides.forEach(function (el) {
          if (mq.matches) { if (el.parentNode !== target) target.appendChild(el); }
          else if (el._popHome && el.parentNode === target) {
            el._popHome.parentNode.insertBefore(el, el._popHome.nextSibling);
          }
        });
      }
      (mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place));
      place();
    }

    if (!links.length) return;
    var ticking = false;
    function spy() {
      var y = window.scrollY + 150, cur = -1;
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top + window.scrollY <= y) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; spy(); }); }
    }, { passive: true });
    spy();
  }

  function stickyAtcSpace(bar) {
    var on = bar.classList.contains('is-on');
    document.body.classList.toggle('pop-has-sticky-atc', on);
    if (on) {
      var h = Math.round(bar.getBoundingClientRect().height);
      if (h) document.documentElement.style.setProperty('--pop-sticky-h', h + 'px');
    }
  }

  function stickyAtc(scope) {
    (scope || document).querySelectorAll('[data-pop-sticky]').forEach(function (bar) {
      if (bar.dataset.popReady) return;
      bar.dataset.popReady = '1';
      var section = bar.dataset.section;
      var button = document.getElementById('ProductSubmitButton-' + section);
      if (!button || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var above = entry.boundingClientRect.top < 0;
        var on = !entry.isIntersecting && above;
        bar.classList.toggle('is-on', on);
        document.documentElement.style.setProperty('--pop-atc-h', on ? bar.offsetHeight + 'px' : '0px');
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyAtcSpace(bar);
      }, { threshold: 0 });
      io.observe(button);
      var price = bar.querySelector('[data-pop-sticky-price]');
      if (price && typeof window.subscribe === 'function') {
        window.subscribe('variant-change', function (e) {
          if (!e || !e.data || e.data.sectionId !== section) return;
          setTimeout(function () {
            var now = document.querySelector('#price-' + section + ' .now');
            if (now) price.textContent = now.textContent;
          }, 60);
        });
      }
    });
  }

  // Collection sort select
  function sortSelects(scope) {
    (scope || document).querySelectorAll('[data-pop-sort]').forEach(function (sel) {
      if (sel.dataset.popReady) return;
      sel.dataset.popReady = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  // Share buttons
  function shareButtons(scope) {
    (scope || document).querySelectorAll('[data-pop-share]').forEach(function (btn) {
      if (btn.dataset.popReady) return;
      btn.dataset.popReady = '1';
      var label = btn.querySelector('span');
      var original = label ? label.textContent : '';
      function done(text) {
        btn.classList.add('is-done');
        if (label) label.textContent = text;
        setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = original; }, 2200);
      }
      btn.addEventListener('click', function () {
        var data = { title: btn.dataset.title || document.title, url: btn.dataset.url || window.location.href };
        if (navigator.share) {
          navigator.share(data).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(data.url).then(function () { done('Link copied'); }, function () { done('Copy failed'); });
        } else {
          window.prompt('Copy this link', data.url);
        }
      });
    });
  }

  // Video cards
  function videoCards(scope) {
    (scope || document).querySelectorAll('[data-pop-vid]').forEach(function (media) {
      if (media.dataset.popReady) return;
      media.dataset.popReady = '1';
      var video = media.querySelector('video');
      var play = media.querySelector('[data-pop-vid-play]');
      if (!video || !play) return;

      play.addEventListener('click', function () {
        document.querySelectorAll('[data-pop-vid].is-playing').forEach(function (other) {
          if (other === media) return;
          var v = other.querySelector('video');
          if (v) v.pause();
          other.classList.remove('is-playing');
        });
        media.classList.add('is-playing');
        video.play().catch(function () { media.classList.remove('is-playing'); });
      });
      video.addEventListener('pause', function () { if (video.currentTime === 0) media.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { media.classList.remove('is-playing'); video.currentTime = 0; });
    });
  }

  // Currency / language dropdowns
  function popLoc(scope) {
    (scope || document).querySelectorAll('[data-pop-loc-menu]').forEach(function (menu) {
      if (menu.dataset.popReady) return;
      menu.dataset.popReady = '1';
      menu.addEventListener('toggle', function () {
        if (!menu.open) return;
        document.querySelectorAll('[data-pop-loc-menu][open]').forEach(function (other) {
          if (other !== menu) other.open = false;
        });
      });
      document.addEventListener('click', function (e) {
        if (menu.open && !menu.contains(e.target)) menu.open = false;
      });

      var filter = menu.querySelector('[data-pop-loc-filter]');
      if (filter) {
        var rows = [].slice.call(menu.querySelectorAll('.pop-loc__row'));
        var none = menu.querySelector('[data-pop-loc-none]');
        filter.addEventListener('input', function () {
          var q = filter.value.trim().toLowerCase();
          var hits = 0;
          rows.forEach(function (row) {
            var on = !q || (row.dataset.match || '').indexOf(q) !== -1;
            row.hidden = !on;
            if (on) hits++;
          });
          if (none) none.hidden = hits > 0;
        });
        menu.addEventListener('toggle', function () { if (menu.open) filter.focus(); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menu.open) {
          menu.open = false;
          var sm = menu.querySelector('summary');
          if (sm) sm.focus();
        }
      });
    });
  }

  // Phone share popup
  function sharePopup(scope) {
    (scope || document).querySelectorAll('[data-pop-sharetrigger]').forEach(function (trigger) {
      if (trigger.dataset.popReady) return;
      trigger.dataset.popReady = '1';
      var dlg = trigger.parentNode.querySelector('[data-pop-sharedlg]');
      if (!dlg || !dlg.showModal) return;
      var copy = dlg.querySelector('[data-pop-copy]');
      var native = dlg.querySelector('[data-pop-native]');
      var root = document.documentElement;

      trigger.addEventListener('click', function () {
        root.classList.add('pop-modal-open');
        dlg.showModal();
      });
      dlg.addEventListener('close', function () {
        root.classList.remove('pop-modal-open');
        trigger.focus();
      });
      dlg.querySelectorAll('[data-pop-shareclose]').forEach(function (x) {
        x.addEventListener('click', function () { dlg.close(); });
      });
      // a click on the
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.querySelectorAll('a.pop-sharerow').forEach(function (a) {
        a.addEventListener('click', function () { dlg.close(); });
      });

      if (copy) {
        var lb = copy.querySelector('.pop-sharerow__lb');
        var original = lb ? lb.textContent : '';
        var mark = function (text) {
          copy.classList.add('is-done');
          if (lb) lb.textContent = text;
          setTimeout(function () { copy.classList.remove('is-done'); if (lb) lb.textContent = original; dlg.close(); }, 1200);
        };
        copy.addEventListener('click', function () {
          var url = copy.dataset.url || window.location.href;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () { mark('Link copied'); }, function () { mark('Copy failed'); });
          } else {
            var t = document.createElement('textarea');
            t.value = url; t.setAttribute('readonly', '');
            t.style.position = 'absolute'; t.style.left = '-9999px';
            document.body.appendChild(t); t.select();
            try { document.execCommand('copy'); mark('Link copied'); } catch (err) { mark('Copy failed'); }
            document.body.removeChild(t);
          }
        });
      }

      if (native && navigator.share) {
        native.hidden = false;
        native.addEventListener('click', function () {
          navigator.share({
            title: native.dataset.title || document.title,
            url: native.dataset.url || window.location.href
          }).catch(function () {});
          dlg.close();
        });
      }
    });
  }

  // The ritual on scroll
  function ritual(scope) {
    (scope || document).querySelectorAll('[data-pop-ritual]').forEach(function (sec) {
      if (sec.dataset.popReady) return;
      sec.dataset.popReady = '1';
      var stage = sec.querySelector('.pop-rt__stage');
      var track = sec.querySelector('.pop-rt__track');
      var bg = sec.querySelector('.pop-rt__bg');
      var panels = [].slice.call(sec.querySelectorAll('.pop-rt__panel'));
      var pills = [].slice.call(sec.querySelectorAll('.pop-rt__pill'));
      var fill = sec.querySelector('.pop-rt__fill');
      var thumb = sec.querySelector('.pop-rt__thumb');
      if (!stage || !track || !panels.length) return;
      var dist = 0, current = -1;
      var padTop = 0; // the section's top padding (seam wave); never use stage.offsetTop, a sticky element reports its stuck position
      function stickyTop() { return parseFloat(getComputedStyle(stage).top) || 0; }
      function measure() {
        var last = panels[panels.length - 1];
        var pad = parseFloat(getComputedStyle(track).paddingRight) || 0;
        var end = last.offsetLeft + last.offsetWidth + pad;
        dist = Math.max(0, Math.round(end - stage.clientWidth));
        padTop = parseFloat(getComputedStyle(sec).paddingTop) || 0;
        var want = Math.round(padTop + stage.offsetHeight + dist);
        sec.style.height = want + 'px';
        var got = sec.offsetHeight;
        if (got !== want) sec.style.height = (want - (got - want)) + 'px';
      }
      function setActive(i) {
        if (i === current) return;
        current = i;
        panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
        var pi = Math.min(i, pills.length - 1);
        pills.forEach(function (p, k) { p.classList.toggle('is-on', k === pi); p.setAttribute('aria-current', k === pi ? 'step' : 'false'); });
      }
      function update() {
        var r = sec.getBoundingClientRect();
        var p = dist > 0 ? (stickyTop() - (r.top + padTop)) / dist : 0;
        p = Math.max(0, Math.min(1, p));
        var x = -p * dist;
        track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
        if (bg) bg.style.transform = 'translate3d(' + (x * 0.5).toFixed(1) + 'px,0,0)';
        var sr = stage.getBoundingClientRect();
        var centre = sr.left + sr.width / 2;
        var best = 0, bestD = Infinity;
        panels.forEach(function (pn, k) {
          var pr = pn.getBoundingClientRect();
          var d = Math.abs(pr.left + pr.width / 2 - centre);
          var near = Math.max(0, 1 - d / (sr.width * 0.85));
          pn.style.setProperty('--near', near.toFixed(3));
          if (d < bestD) { bestD = d; best = k; }
        });
        setActive(best);
        if (fill) fill.style.width = (p * 100).toFixed(2) + '%';
        if (thumb) thumb.style.left = (p * 100).toFixed(2) + '%';
        sec.classList.toggle('is-done', p > 0.98);
      }
      function goTo(k) {
        var pn = panels[k];
        if (!pn) return;
        var target = pn.offsetLeft + pn.offsetWidth / 2 - stage.clientWidth / 2;
        var pk = dist > 0 ? Math.max(0, Math.min(1, target / dist)) : 0;
        var r = sec.getBoundingClientRect();
        var y = window.scrollY + (r.top + padTop - stickyTop()) + pk * dist;
        try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
      }
      pills.forEach(function (p) { p.addEventListener('click', function () { goTo(parseInt(p.dataset.i, 10)); }); });
      panels.forEach(function (pn, k) {
        pn.addEventListener('click', function (e) { if (e.target.closest('a, button')) return; if (k !== current) goTo(k); });
      });
      var ticking = false;
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); update(); });
      window.addEventListener('load', function () { measure(); update(); });
      measure();
      update();
    });
  }

  // Footer country selector
  function locSelects(scope) {
    (scope || document).querySelectorAll('select[data-pop-loc]').forEach(function (sel) {
      if (sel.dataset.popBound) return;
      sel.dataset.popBound = '1';
      sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
    });
  }

  // Reviews carousel, mobile only. Splide destroys itself at 900px and the grid
  // takes over, so desktop pays nothing for it.
  // Shop policy bodies were pasted out of a chat window. They carry empty <a></a> nodes, raw
  // urls as the link text, and parentheses trapped inside the anchor, so a sentence renders as
  // "govern your use of (https://ubiyam.com)(the "Site")". This repairs the rendering only;
  // the stored policy text is untouched.
  function policyLinks(scope) {
    var root = (scope || document).querySelector('.pop-policy .pop-page__content');
    if (!root) return;

    Array.prototype.forEach.call(root.querySelectorAll('a'), function (a) {
      if (a.id || a.getAttribute('name')) return;
      if (a.textContent.trim() || a.querySelector('img, svg, picture, video')) return;
      a.remove();
    });

    Array.prototype.forEach.call(root.querySelectorAll('a[href]'), function (a) {
      var m = a.textContent.trim().match(/^\(?\s*(https?:\/\/[^\s)]+?)\s*\)?$/i);
      if (!m) return;
      a.textContent = m[1].replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/+$/, '');
    });

    var blocks = root.querySelectorAll('p, li, td, th, h1, h2, h3, h4, h5, h6');
    Array.prototype.forEach.call(blocks, function (block) {
      if (!block.querySelector('a[href]')) return;
      var walk = document.createTreeWalker(block, NodeFilter.SHOW_TEXT, null);
      var prevText = null, curLink = null, afterLink = null, t;
      while ((t = walk.nextNode())) {
        var link = t.parentElement && t.parentElement.closest('a[href]');
        if (link) {
          if (link !== curLink) {
            curLink = link;
            if (prevText && /[\w),.:;]$/.test(prevText.textContent)) prevText.textContent += ' ';
          }
          afterLink = link;
          continue;
        }
        if (afterLink && /^[([\w]/.test(t.textContent)) t.textContent = ' ' + t.textContent;
        afterLink = null;
        prevText = t;
      }
    });
  }

  function revCarousel(scope) {
    var roots = (scope || document).querySelectorAll('[data-pop-revsplide]');
    if (!roots.length) return;
    var start = function () {
      roots.forEach(function (root) {
        if (root.dataset.popMounted || !window.Splide) return;
        root.dataset.popMounted = '1';
        var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var ctrl = root.parentElement && root.parentElement.querySelector('[data-pop-revctrl]');
        var sp = new Splide(root, {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          gap: '16px',
          drag: true,
          arrows: false,
          pagination: true,
          speed: slow ? 0 : 480,
          easing: 'cubic-bezier(0.2, 0.7, 0.25, 1)',
          mediaQuery: 'min',
          breakpoints: { 900: { destroy: true } }
        });
        // Crossing 900px destroys the instance, and Splide re-mounts it on the way back
        // with a freshly built pagination inside the root. A single mounted handler only
        // fires the first time, so the control row went missing for good after one round
        // trip. Watching the root keeps it in step however many times the width crosses.
        var sync = function () {
          if (!ctrl) return;
          var live = root.classList.contains('is-initialized');
          if (live) {
            var pg = root.querySelector('.splide__pagination');
            var next = ctrl.querySelector('[data-pop-rev-next]');
            if (pg && next && pg.parentElement !== ctrl) ctrl.insertBefore(pg, next);
          }
          ctrl.hidden = !live;
        };
        if (ctrl && window.MutationObserver) {
          new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'], childList: true });
        }
        sp.on('mounted updated refresh', sync);
        var popTouched = false;
        root.addEventListener('pointerdown', function () { popTouched = true; }, { passive: true });
        var popSettle = function () {
          try {
            sp.refresh();
            if (!popTouched && sp.Components && sp.Components.Move && sp.Components.Move.jump) {
              sp.Components.Move.jump(0);
            }
          } catch (e) {}
        };
        if (document.readyState !== 'complete') {
          window.addEventListener('load', popSettle, { once: true });
        }
        window.setTimeout(popSettle, 450);
        window.setTimeout(popSettle, 1500);
        sp.mount();
        sync();
        if (ctrl) {
          var prev = ctrl.querySelector('[data-pop-rev-prev]');
          var nx = ctrl.querySelector('[data-pop-rev-next]');
          if (prev) prev.addEventListener('click', function () { sp.go('<'); });
          if (nx) nx.addEventListener('click', function () { sp.go('>'); });
        }
      });
    };
    // Splide is only fetched once the viewport actually needs it, so a desktop
    // visitor never downloads the library for this section.
    function withSplide(cb) {
      if (window.Splide) return cb();
      var tag = document.querySelector('script[src*="splide"]');
      if (!tag && window.popSplideSrc) {
        tag = document.createElement('script');
        tag.src = window.popSplideSrc;
        tag.defer = true;
        document.head.appendChild(tag);
      }
      if (!tag) return;
      var n = 0;
      (function poll() { if (window.Splide) return cb(); if (++n > 80) return; window.setTimeout(poll, 150); })();
    }
    var mq = window.matchMedia('(max-width: 899px)');
    var kick = function () { if (mq.matches) withSplide(start); };
    kick();
    if (mq.addEventListener) mq.addEventListener('change', kick);
    else if (mq.addListener) mq.addListener(kick);
  }

  function vidCarousel(scope) {
    var roots = (scope || document).querySelectorAll('[data-pop-vidsplide]');
    if (!roots.length) return;
    var start = function () {
      roots.forEach(function (root) {
        if (root.dataset.popMounted || !window.Splide) return;
        root.dataset.popMounted = '1';
        var per = parseInt(root.dataset.per, 10) || 3;
        var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var sp = new Splide(root, {
          type: 'loop',
          perPage: per,
          perMove: 1,
          gap: '18px',
          drag: true,
          arrows: false,
          pagination: false,
          speed: slow ? 0 : 520,
          easing: 'cubic-bezier(0.2, 0.7, 0.25, 1)',
          breakpoints: {
            1199: { perPage: Math.min(per, 3) },
            899: { perPage: 2 },
            599: { perPage: 1, gap: '14px', padding: { left: '12%', right: '12%' } }
          }
        });

        var ctrl = root.parentElement && root.parentElement.querySelector('[data-pop-vidctrl]');
        var total = root.querySelectorAll('.splide__slide:not(.splide__slide--clone)').length;
        var dots = null, stops = 0;

        function stopCount() {
          var shown = sp.options.perPage || 1;
          if (sp.state && sp.Components && sp.Components.Layout) {
            shown = sp.Components.Layout.slideSize ? shown : shown;
          }
          return Math.max(1, total - shown + 1);
        }
        function paintDots() {
          if (!dots) return;
          var i = sp.index;
          if (i > stops - 1) i = stops - 1;
          if (i < 0) i = 0;
          [].forEach.call(dots.children, function (li, n) {
            li.firstChild.classList.toggle('is-active', n === i);
            li.firstChild.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }
        function buildDots() {
          if (!ctrl) return;
          var n = stopCount();
          if (dots && n === stops) { paintDots(); return; }
          stops = n;
          if (!dots) {
            dots = document.createElement('ul');
            dots.className = 'pop-vidwall__dots';
            dots.setAttribute('role', 'tablist');
            ctrl.insertBefore(dots, ctrl.querySelector('[data-pop-vid-next]'));
          }
          dots.innerHTML = '';
          for (var i = 0; i < stops; i++) {
            var li = document.createElement('li');
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'pop-vidwall__dot';
            btn.setAttribute('aria-label', 'Go to clip ' + (i + 1));
            btn.dataset.go = i;
            btn.addEventListener('click', function () { sp.go(+this.dataset.go); });
            li.appendChild(btn);
            dots.appendChild(li);
          }
          paintDots();
        }
        sp.on('move', function () {
          root.querySelectorAll('[data-pop-vid].is-playing').forEach(function (m) {
            var v = m.querySelector('video');
            if (v) v.pause();
            m.classList.remove('is-playing');
          });
        });
        sp.on('mounted updated resized', buildDots);
        sp.on('move moved', paintDots);
        var popTouched = false;
        root.addEventListener('pointerdown', function () { popTouched = true; }, { passive: true });
        var popSettle = function () {
          try {
            sp.refresh();
            if (!popTouched && sp.Components && sp.Components.Move && sp.Components.Move.jump) {
              sp.Components.Move.jump(0);
            }
          } catch (e) {}
        };
        if (document.readyState !== 'complete') {
          window.addEventListener('load', popSettle, { once: true });
        }
        window.setTimeout(popSettle, 450);
        window.setTimeout(popSettle, 1500);
        sp.mount();
        if (ctrl) {
          var prev = ctrl.querySelector('[data-pop-vid-prev]');
          var next = ctrl.querySelector('[data-pop-vid-next]');
          // the rail still loops
          if (prev) prev.addEventListener('click', function () { sp.go(sp.index <= 0 ? stops - 1 : sp.index - 1); });
          if (next) next.addEventListener('click', function () { sp.go(sp.index >= stops - 1 ? 0 : sp.index + 1); });
        }
        videoCards(root);
      });
    };
    if (window.Splide) start();
    else window.addEventListener('load', start, { once: true });
  }

  function pvidCarousel(scope) {
    var roots = (scope || document).querySelectorAll('[data-pop-pvidsplide]');
    if (!roots.length) return;
    var start = function () {
      roots.forEach(function (root) {
        if (root.dataset.popMounted || !window.Splide) return;
        var total = root.querySelectorAll('.splide__slide').length;
        if (total < 2) return;
        root.dataset.popMounted = '1';
        var slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var sp = new Splide(root, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '12px',
          drag: true,
          arrows: false,
          pagination: false,
          speed: slow ? 0 : 460,
          easing: 'cubic-bezier(0.2, 0.7, 0.25, 1)',
          padding: { left: 0, right: '13%' },
          breakpoints: {
            749: { perPage: 2, gap: '9px', padding: { left: 0, right: '16%' } }
          }
        });

        var host = root.parentElement;
        var dots = host && host.querySelector('[data-pop-pviddots]');
        var stops = 0;

        function paint() {
          if (!dots) return;
          var i = sp.index;
          if (i > stops - 1) i = stops - 1;
          if (i < 0) i = 0;
          [].forEach.call(dots.children, function (li, n) {
            li.firstChild.classList.toggle('is-active', n === i);
            li.firstChild.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }
        function build() {
          if (!dots) return;
          var n = Math.max(1, total);
          if (n === stops) { paint(); return; }
          stops = n;
          dots.innerHTML = '';
          for (var i = 0; i < stops; i++) {
            var li = document.createElement('li');
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pop-pvid__dot';
            b.setAttribute('aria-label', 'Go to clip ' + (i + 1));
            b.dataset.go = String(i);
            b.addEventListener('click', function () { popTouched = true; sp.go(parseInt(this.dataset.go, 10)); });
            li.appendChild(b);
            dots.appendChild(li);
          }
          dots.hidden = stops < 2;
          paint();
        }

        function dim() {
          var tr = root.querySelector('.splide__track');
          if (!tr) return;
          var box = tr.getBoundingClientRect();
          var cs = window.getComputedStyle(tr);
          var lim = { l: box.left + (parseFloat(cs.paddingLeft) || 0), r: box.right - (parseFloat(cs.paddingRight) || 0) };
          root.querySelectorAll('.splide__slide').forEach(function (sl) {
            var r = sl.getBoundingClientRect();
            sl.classList.toggle('is-peek', r.right > lim.r + 2 || r.left < lim.l - 2);
          });
        }
        var dimSoon = function () { window.setTimeout(dim, 40); window.setTimeout(dim, 520); };
        sp.on('mounted updated resized', function () { build(); dimSoon(); });
        sp.on('move moved', function () { paint(); dimSoon(); });
        var popTouched = false;
        root.addEventListener('pointerdown', function () { popTouched = true; }, { passive: true });
        var popSettle = function () {
          try {
            sp.refresh();
            if (!popTouched && sp.Components && sp.Components.Move && sp.Components.Move.jump) {
              sp.Components.Move.jump(0);
            }
          } catch (e) {}
        };
        if (document.readyState !== 'complete') {
          window.addEventListener('load', popSettle, { once: true });
        }
        window.setTimeout(popSettle, 450);
        window.setTimeout(popSettle, 1500);
        sp.mount();
        dimSoon();
        if (host) {
          var pv = host.querySelector('[data-pop-pvidprev]');
          var nx = host.querySelector('[data-pop-pvidnext]');
          if (pv) pv.addEventListener('click', function () { sp.go('<'); });
          if (nx) nx.addEventListener('click', function () { sp.go('>'); });
        }
        videoCards(root);
      });
    };
    if (window.Splide) start();
    else window.addEventListener('load', start, { once: true });
  }

  function urgency(scope) {
    var found = (scope || document).querySelectorAll('[data-pop-countdown]');
    var els = [];
    [].forEach.call(found, function (el) {
      if (el.dataset.popCd) return;
      el.dataset.popCd = '1';
      els.push(el);
    });
    if (!els.length) return;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var write = function (el, k, v) {
      var n = el.querySelector('[data-cd="' + k + '"]');
      if (n && n.textContent !== v) n.textContent = v;
    };
    var tick = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
      var left = end.getTime() - now.getTime();
      if (left < 0) left = 0;
      var t = Math.floor(left / 1000);
      var d = Math.floor(t / 86400);
      var h = Math.floor((t % 86400) / 3600);
      var m = Math.floor((t % 3600) / 60);
      var sec = t % 60;
      els.forEach(function (el) {
        write(el, 'd', String(d));
        write(el, 'h', pad(h));
        write(el, 'm', pad(m));
        write(el, 's', pad(sec));
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  // Live-viewer counter on the product page. The number is decorative, but it is
  // meant to read as a real one: it walks a step at a time on an uneven interval
  // and it is remembered per product, so a reload carries on from where it was
  // instead of resetting to a fresh random number every time.
  function viewers(scope) {
    var found = (scope || document).querySelectorAll('[data-pop-viewers]');
    [].forEach.call(found, function (el) {
      if (el.dataset.popVw) return;
      el.dataset.popVw = '1';
      var out = el.querySelector('[data-pop-vn]');
      if (!out) return;

      var lo = parseInt(el.dataset.min, 10);
      var hi = parseInt(el.dataset.max, 10);
      if (!(lo > 0)) lo = 5;
      if (!(hi > lo)) hi = lo + 5;
      var wLo = parseFloat(el.dataset.everyMin);
      var wHi = parseFloat(el.dataset.everyMax);
      if (!(wLo > 0)) wLo = 10;
      if (!(wHi > wLo)) wHi = wLo + 50;
      var key = 'pop-vw-' + (el.dataset.key || 'x');

      var wait = function () { return (wLo + Math.random() * (wHi - wLo)) * 1000; };
      var walk = function (v) {
        var move = Math.random() < 0.5 ? -1 : 1;
        if (Math.random() < 0.22) move *= 2;
        v += move;
        if (v < lo) v = lo + Math.abs(move);
        if (v > hi) v = hi - Math.abs(move);
        if (v < lo) v = lo;
        if (v > hi) v = hi;
        return v;
      };
      var read = function () {
        try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (e) { return null; }
      };
      var write = function (v) {
        try { window.localStorage.setItem(key, JSON.stringify({ n: v, t: Date.now() })); } catch (e) {}
      };

      var n;
      var saved = read();
      if (saved && saved.n >= lo && saved.n <= hi) {
        // carry on from last visit, moved on by however long they were away,
        // capped so a week-old value does not unwind the whole range
        n = saved.n;
        var gone = (Date.now() - (saved.t || 0)) / 1000;
        var steps = Math.min(3, Math.floor(gone / wHi));
        while (steps-- > 0) n = walk(n);
      } else {
        n = lo + Math.floor(Math.random() * (hi - lo + 1));
      }
      out.textContent = String(n);
      write(n);

      var step = function () {
        n = walk(n);
        out.textContent = String(n);
        write(n);
        setTimeout(step, wait());
      };
      setTimeout(step, wait());
    });
  }

  function bundleSavings() {
    if (document.documentElement.dataset.popKbSave) return;
    document.documentElement.dataset.popKbSave = '1';
    var tries = 0;
    var money = function (t) {
      if (!t) return NaN;
      var v = String(t).replace(/[^0-9.,]/g, '');
      if (!v) return NaN;
      if (v.lastIndexOf(',') > v.lastIndexOf('.')) v = v.replace(/\./g, '').replace(',', '.');
      else v = v.replace(/,/g, '');
      return parseFloat(v);
    };
    var band = function (bar) {
      var line = bar.querySelector('.kaching-bundles__bar-first-line');
      var chip = bar.querySelector('.pop-kb-save');
      var box = bar.querySelector('.kaching-bundles__bar-container');
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
      var gifts = bar.querySelectorAll('.kaching-bundles__free-gift').length;
      var now = money(priceEl && priceEl.textContent);
      var was = money(fullEl && fullEl.textContent);
      var pct = isFinite(now) && isFinite(was) && was > now ? Math.round((1 - now / was) * 100) : 0;
      if (!box || !line || (pct < 5 && !gifts)) {
        if (chip && chip.parentNode) chip.parentNode.removeChild(chip);
        return;
      }
      if (!chip) {
        chip = document.createElement('span');
        chip.className = 'pop-kb-save';
        box.appendChild(chip);
      }
      var key = pct + '';
      if (chip.dataset.key !== key) {
        chip.dataset.key = key;
        chip.textContent = pct >= 5 ? 'SAVE ' + pct + '%' : '';
      }
      var lab = box.querySelector('.pop-kb-free');
      if (gifts > 0) {
        if (!lab) {
          lab = document.createElement('span');
          lab.className = 'pop-kb-free';
          box.appendChild(lab);
        }
        var ltxt = gifts + (gifts === 1 ? ' FREE ITEM' : ' FREE ITEMS');
        if (lab.textContent !== ltxt) lab.textContent = ltxt;
      } else if (lab && lab.parentNode) {
        lab.parentNode.removeChild(lab);
      }
    };
    var showcase = function (tiers) {
      if (!tiers || !tiers.parentNode) return;
      var sel = tiers.querySelector('.kaching-bundles__bar--selected');
      var host = tiers.parentNode;
      var panel = host.querySelector('.pop-kb-gifts');
      var gifts = sel ? sel.querySelectorAll('.kaching-bundles__free-gift') : [];
      if (!gifts.length) {
        if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
        return;
      }
      var items = [].map.call(gifts, function (g) {
        var im = g.querySelector('.kaching-bundles__free-gift__image');
        var tx = g.querySelector('.kaching-bundles__free-gift__text');
        var vl = g.querySelector('.kaching-bundles__free-gift__full-price');
        return {
          src: im ? im.getAttribute('src') : '',
          name: tx ? tx.textContent.trim().replace(/^FREE\s+/i, '') : '',
          val: vl ? vl.textContent.trim() : ''
        };
      });
      var key = items.map(function (i) { return i.name + i.val; }).join('|');
      if (panel && panel.dataset.key === key) return;
      if (!panel) {
        panel = document.createElement('div');
        panel.className = 'pop-kb-gifts';
        host.insertBefore(panel, tiers.nextSibling);
      }
      panel.dataset.key = key;
      panel.textContent = '';
      var h = document.createElement('p');
      h.className = 'pop-kb-gifts__h';
      h.textContent = items.length === 1 ? 'Yours free with this bundle' : 'Yours free with this bundle';
      panel.appendChild(h);
      var ul = document.createElement('ul');
      ul.className = 'pop-kb-gifts__list';
      items.forEach(function (it) {
        var li = document.createElement('li');
        if (it.src) {
          var im = document.createElement('img');
          im.src = it.src;
          im.alt = '';
          im.loading = 'lazy';
          li.appendChild(im);
        }
        var fr = document.createElement('span');
        fr.className = 'pop-kb-gifts__f';
        fr.textContent = 'FREE';
        li.appendChild(fr);
        var nm = document.createElement('span');
        nm.className = 'pop-kb-gifts__n';
        nm.textContent = it.name;
        li.appendChild(nm);
        if (it.val) {
          var v = document.createElement('span');
          v.className = 'pop-kb-gifts__v';
          v.textContent = it.val;
          li.appendChild(v);
        }
        ul.appendChild(li);
      });
      panel.appendChild(ul);
    };
    var atc = function (tiers) {
      var priceEl = tiers && tiers.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
      if (!priceEl) return;
      var want = priceEl.textContent.trim();
      var spans = document.querySelectorAll('.pop-product__buy button[name="add"] > span, .pop-sticky-atc button[name="add"] > span');
      [].forEach.call(spans, function (sp) {
        var tag = sp.querySelector('.pop-atc-price');
        if (!tag) {
          tag = document.createElement('span');
          tag.className = 'pop-atc-price';
          sp.appendChild(tag);
        }
        if (tag.textContent !== want) tag.textContent = want;
      });
      // The sticky bar only listened for variant-change, which Kaching never fires, so it kept
      // showing the one-pouch price after a bigger pack was picked. Mirror the tier price there too.
      [].forEach.call(document.querySelectorAll('.pop-sticky-atc [data-pop-sticky-price]'), function (el) {
        if (el.textContent !== want) el.textContent = want;
      });
    };
    var paint = function (root) {
      var tiers = root.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions)');
      if (tiers && !tiers.classList.contains('kb3')) tiers.classList.add('kb3');
      root.querySelectorAll('.kaching-bundles__bar').forEach(band);
      showcase(tiers);
      atc(tiers);
    };
    var attach = function (root) {
      var queued = false;
      var run = function () { queued = false; paint(root); };
      var kick = function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(run);
      };
      paint(root);
      new MutationObserver(kick).observe(root, { childList: true, subtree: true, characterData: true });
      root.addEventListener('click', function () { window.setTimeout(kick, 60); });
    };
    var look = function () {
      var root = document.querySelector('.kaching-bundles');
      if (root) { attach(root); return; }
      if (++tries > 60) return;
      window.setTimeout(look, 400);
    };
    look();
  }

  function quickAdd(scope) {
    (scope || document).querySelectorAll('form[data-pop-quickadd]').forEach(function (f) {
      if (f.dataset.popBound) return;
      f.dataset.popBound = '1';
      f.addEventListener('submit', function (e) {
        if (!window.fetch || !window.FormData) return;
        e.preventDefault();
        var btn = f.querySelector('button');
        if (btn && btn.dataset.busy) return;
        var label = btn ? btn.textContent : '';
        if (btn) { btn.dataset.busy = '1'; btn.textContent = 'Adding'; }
        var drawer = document.querySelector('cart-drawer');
        var done = function (ok) {
          if (!btn) return;
          btn.textContent = ok ? 'Added' : 'Try again';
          window.setTimeout(function () {
            btn.textContent = label;
            delete btn.dataset.busy;
          }, 1600);
        };
        fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () {
            var cartSection = drawer ? (drawer.dataset.sectionId || 'cart-drawer') : null;
            return fetch('/?sections=cart-icon-bubble' + (cartSection ? ',' + cartSection : ''))
              .then(function (r) { return r.json(); })
              .then(function (sec) {
                var bubble = document.getElementById('cart-icon-bubble');
                if (bubble && sec['cart-icon-bubble']) {
                  var tmp = document.createElement('div');
                  tmp.innerHTML = sec['cart-icon-bubble'];
                  var fresh = tmp.querySelector('#cart-icon-bubble');
                  if (fresh) bubble.innerHTML = fresh.innerHTML;
                }
                if (cartSection && sec[cartSection]) {
                  var t2 = document.createElement('div');
                  t2.innerHTML = sec[cartSection];
                  var fd = t2.querySelector('cart-drawer');
                  if (fd) drawer.innerHTML = fd.innerHTML;
                  drawer.classList.remove('is-empty');
                  try { if (typeof drawer.open === 'function') drawer.open(); } catch (err) {}
                }
              })
              .catch(function () {});
          })
          .then(function () { done(true); })
          .catch(function () { done(false); });
      });
    });
  }


  // The upsell variant picker, where a product has more than one. The price next
  // to it follows the chosen option so the shopper never has to guess.
  function upVariant(scope) {
    (scope || document).querySelectorAll('[data-pop-upvariant]').forEach(function (sel) {
      if (sel.dataset.popBound) return;
      sel.dataset.popBound = '1';
      sel.addEventListener('change', function () {
        var item = sel.closest('.pop-cartup__item');
        var box = item && item.querySelector('[data-pop-upprice]');
        if (!box) return;
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var now = opt.getAttribute('data-price') || '';
        var was = opt.getAttribute('data-was') || '';
        var first = box.firstChild;
        if (first && first.nodeType === 3) first.nodeValue = now;
        else box.insertBefore(document.createTextNode(now), box.firstChild);
        var strike = box.querySelector('[data-pop-upwas]');
        if (strike) {
          strike.textContent = was;
          strike.hidden = !was;
        }
      });
    });
  }

  // Tier gifts that survive the drawer.
  //
  // The bundle app only runs its offer logic at add-to-cart time, so pressing +
  // or - inside the drawer leaves the cart holding the wrong number of gifts.
  // The Cart section's Gift rule blocks describe the offer as data; this reads
  // them back after every cart render and makes the cart match.
  //
  // Ownership: a gift this put there carries a hidden _gift line property naming
  // the rule. With "adopt" on, plain lines of the same product count as the
  // rule's too, which is what lets a gift the app added disappear again.
  function giftRules() {
    var host = document.querySelector('cart-drawer');
    if (!host || host.dataset.popGiftBound) return;
    host.dataset.popGiftBound = '1';

    var busy = false;
    // Add ?popdebug=1 to any URL to watch the rules decide. The promise chain below
    // catches everything so a hiccup never wedges a shopper's cart, which also
    // means a genuine mistake in here is invisible without this.
    var loud = /[?&]popdebug=1/.test(window.location.search);
    var strikes = {};
    function say() {
      if (loud && window.console) console.log.apply(console, ['[gift]'].concat([].slice.call(arguments)));
    }

    // A rule whose gift nothing discounted is parked for the session rather than
    // retried on every page, which would mean two cart writes per page for nothing.
    var abandoned = {};
    try { abandoned = JSON.parse(window.sessionStorage.getItem('pop-gift-off') || '{}') || {}; } catch (e) { abandoned = {}; }
    function park(id) {
      abandoned[id] = 1;
      try { window.sessionStorage.setItem('pop-gift-off', JSON.stringify(abandoned)); } catch (e) {}
      if (window.console && console.warn) {
        console.warn('[ubiyam] gift rule "' + id + '" is off for this session: nothing discounted the gift to zero, ' +
                     'so it was removed rather than charged for. A theme cannot set prices. Either the bundle app\'s ' +
                     'deal has no free gift on this tier, or its line property did not carry over.');
      }
    }

    // Which lines have been free at some point. A gift the bundle app added is
    // free while its tier holds and priced again the moment the shopper drops
    // below it, so "is it free right now" is not enough to tell a gift from a
    // purchase. Line keys survive quantity changes, so remembering them is.
    var FREE_KEY = 'pop-gift-free';
    var wasFree = {};
    try { wasFree = JSON.parse(window.localStorage.getItem(FREE_KEY) || '{}') || {}; } catch (e) { wasFree = {}; }

    function noteFree(cart) {
      var seen = {};
      var dirty = false;
      cart.items.forEach(function (it) {
        seen[it.key] = 1;
        if (it.final_line_price === 0 && !wasFree[it.key]) {
          wasFree[it.key] = 1;
          dirty = true;
        }
      });
      // drop keys for lines that have left the cart, so this cannot grow forever
      Object.keys(wasFree).forEach(function (k) {
        if (!seen[k]) { delete wasFree[k]; dirty = true; }
      });
      if (!dirty) return;
      try { window.localStorage.setItem(FREE_KEY, JSON.stringify(wasFree)); } catch (e) {}
    }

    function rules() {
      var el = host.querySelector('[data-pop-giftrules]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent) || [];
      } catch (e) {
        return [];
      }
    }

    function send(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); });
    }

    function cartNow() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.text().then(function (txt) {
          // A throttled storefront answers with an HTML challenge, and JSON.parse
          // then fails in a way that reads exactly like an empty cart.
          if (txt.charAt(0) !== '{') throw new Error('cart.js did not return JSON (' + r.status + ')');
          return JSON.parse(txt);
        });
      });
    }

    // How many gifts the rule asks for, given what is in the cart.
    function wanted(rule, cart) {
      var n = counted(rule, cart);
      if (n < rule.at) return 0;
      var g = 1;
      if (rule.every > 0) g += Math.floor((n - rule.at) / rule.every);
      if (rule.max > 0) g = Math.min(g, rule.max);
      return g;
    }

    // The bundle app marks every line of a deal with a hidden __kaching_bundles
    // property and its discount function prices from that. A line added without it
    // is just a product the shopper pays for.
    //
    // A gift's payload is not the main line's: the main line carries
    // {deal, pp, main:true, v, id, bid, sellingPlan}, a gift carries only
    // {id, deal, v, gift}, where gift is the offer's id in the app's own deal
    // config. So take the deal identity off the line the shopper actually chose
    // and name the offer, rather than copying a payload that says "main bundle".
    function dealTag(cart) {
      var fallback = null;
      for (var i = 0; i < cart.items.length; i++) {
        var raw = (cart.items[i].properties || {}).__kaching_bundles;
        if (typeof raw !== 'string' || !raw) continue;
        try {
          var d = JSON.parse(raw);
          if (!d || !d.deal || !d.id) continue;
          // the line the shopper actually chose is the one marked main; a gift's
          // own tag would do for id/deal/v but this keeps the source obvious
          if (d.main) return d;
          if (!fallback) fallback = d;
        } catch (e) {}
      }
      return fallback;
    }

    function carried(rule, cart) {
      var out = {};
      if (!rule.carry || !rule.deal_gift) return out;
      var tag = dealTag(cart);
      if (!tag) return out;
      out.__kaching_bundles = JSON.stringify({
        id: tag.id,
        deal: tag.deal,
        v: tag.v,
        gift: rule.deal_gift
      });
      return out;
    }

    // Is this line a gift the bundle app placed? Its tag says so outright: a gift
    // payload carries a "gift" key naming the offer. That beats guessing from the
    // price, because the app re-prices the moment the tier changes, and it beats
    // remembering line keys, because the app rebuilds lines.
    function appGift(it) {
      var raw = (it.properties || {}).__kaching_bundles;
      if (typeof raw !== 'string' || !raw) return false;
      try {
        var d = JSON.parse(raw);
        return !!(d && d.gift);
      } catch (e) {
        return false;
      }
    }

    // Lines the rule may change: its own first, then adopted ones. A plain line is
    // only adopted if something marks it as a gift rather than a purchase.
    function owned(rule, cart) {
      var mine = [];
      var theirs = [];
      cart.items.forEach(function (it) {
        var props = it.properties || {};
        if (props._gift === rule.id) mine.push(it);
        else if (rule.adopt && !props._gift && it.variant_id === rule.gift &&
                 (appGift(it) || it.final_line_price === 0 || wasFree[it.key])) theirs.push(it);
      });
      return mine.concat(theirs);
    }

    // How many of the counted product are in the cart, gifts never counting.
    function counted(rule, cart) {
      var n = 0;
      cart.items.forEach(function (it) {
        var props = it.properties || {};
        if (props._gift) return;
        if (rule.adopt && it.variant_id === rule.gift) return;
        if (rule.trigger && it.product_id !== rule.trigger) return;
        n += it.quantity;
      });
      return n;
    }

    // A step rule only holds while it is the highest step reached, which is how
    // quantity breaks work: two packs earn one gift, three earn a different one
    // rather than both.
    function stoodDown(rule, all, cart) {
      if (!rule.tier) return false;
      var mine = counted(rule, cart);
      var best = 0;
      all.forEach(function (r) {
        if (!r.tier) return;
        if (counted(r, cart) >= r.at && r.at > best) best = r.at;
      });
      return best > 0 && rule.at < best && mine >= rule.at;
    }

    function run(j) {
      return send(j.url, j.body).catch(function (err) {
        if (window.console && console.warn) console.warn('[ubiyam] gift rule could not ' + j.url, err && err.status, j.body);
      });
    }

    // What the cart would need for every rule to hold, as a list of cart writes.
    function plan(cart) {
      var live = rules().filter(function (r) { return r.gift; });
      var jobs = [];
      live.forEach(function (rule) {
        var lines = owned(rule, cart);
        var have = 0;
        lines.forEach(function (l) { have += l.quantity; });
        var down = stoodDown(rule, live, cart);
        var need = down ? 0 : wanted(rule, cart);
        say(rule.id + ': counted=' + counted(rule, cart) + ' at=' + rule.at +
            ' have=' + have + ' need=' + need + (down ? ' (stood down)' : '') +
            ' owns=' + JSON.stringify(lines.map(function (l) { return l.title.slice(0, 18) + '@' + l.final_line_price; })));
        if (need === have) return;
        if (need > have) {
          if (abandoned[rule.id]) {
            say(rule.id + ': parked, not adding');
            return;
          }
          if (lines.length && (lines[0].properties || {})._gift === rule.id) {
            jobs.push({ kind: 'bump', url: '/cart/change.js',
                        body: { id: lines[0].key, quantity: lines[0].quantity + (need - have) } });
          } else {
            var props = carried(rule, cart);
            props._gift = rule.id;
            jobs.push({ kind: 'add', url: '/cart/add.js',
                        body: { items: [{ id: rule.gift, quantity: need - have, properties: props }] } });
          }
          return;
        }
        // too many: trim from the end of the list, so adopted lines go first
        var over = have - need;
        for (var i = lines.length - 1; i >= 0 && over > 0; i--) {
          var take = Math.min(over, lines[i].quantity);
          jobs.push({ kind: 'remove', url: '/cart/change.js',
                      body: { id: lines[i].key, quantity: lines[i].quantity - take } });
          over -= take;
        }
      });
      return jobs;
    }

    function reconcile() {
      var live = rules().filter(function (r) { return r.gift; });
      say('reconcile: ' + live.length + ' rule(s), busy=' + busy);
      if (!live.length || busy) return Promise.resolve(false);
      busy = true;
      return cartNow()
        .then(function (cart) {
          noteFree(cart);
          var jobs = plan(cart);
          say('jobs', JSON.stringify(jobs));
          if (!jobs.length) return false;

          // Order matters. Take the stale gift out first: while both sit in the
          // cart it matches no tier, so the app will not zero the new one, and
          // adding rebuilds the lines which makes the removal's key stale. Then
          // re-plan the additions against the cart the removals actually left.
          var drop = jobs.filter(function (j) { return j.kind === 'remove'; });
          var rest = jobs.filter(function (j) { return j.kind !== 'remove'; });
          var chain = Promise.resolve();
          drop.forEach(function (j) { chain = chain.then(function () { return run(j); }); });
          if (!rest.length) return chain.then(function () { return true; });
          return chain
            .then(cartNow)
            .then(function (fresh) {
              var again = plan(fresh).filter(function (j) { return j.kind !== 'remove'; });
              say('after removals', JSON.stringify(again));
              var c2 = Promise.resolve();
              again.forEach(function (j) { c2 = c2.then(function () { return run(j); }); });
              return c2.then(function () { return true; });
            });
        })
        .then(function (changed) {
          if (!changed) return false;
          // A gift nothing discounted is a gift the shopper would be charged for.
          var guard = rules().filter(function (r) { return r.free_only; });
          if (!guard.length) return true;
          return cartNow().then(function (cart) {
            var strays = [];
            guard.forEach(function (rule) {
              cart.items.forEach(function (it) {
                if ((it.properties || {})._gift !== rule.id) return;
                if (it.final_line_price > 0) {
                  strays.push(it.key);
                  // One failure can just be a cart caught mid-change. Park the
                  // rule only when it fails twice, so a hiccup does not kill the
                  // offer for the rest of the session.
                  strikes[rule.id] = (strikes[rule.id] || 0) + 1;
                  if (strikes[rule.id] >= 2) park(rule.id);
                  else say(rule.id + ': gift was not zeroed, will try once more');
                }
              });
            });
            if (!strays.length) return true;
            var chain = Promise.resolve();
            strays.forEach(function (k) {
              chain = chain.then(function () { return send('/cart/change.js', { id: k, quantity: 0 }).catch(function () {}); });
            });
            return chain.then(function () { return true; });
          });
        })
        .catch(function (err) {
          if (window.console && console.warn) console.warn('[ubiyam] gift rules stopped early', err);
          return false;
        })
        .then(function (changed) {
          busy = false;
          say('done, changed=' + changed);
          return changed;
        });
    }

    function repaint() {
      var id = host.dataset.sectionId || 'cart-drawer';
      return fetch('/?sections=' + encodeURIComponent(id) + ',cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sec) {
          var box = document.getElementById('CartDrawer');
          if (box && sec[id]) {
            var t = document.createElement('div');
            t.innerHTML = sec[id];
            var fresh = t.querySelector('#CartDrawer');
            if (fresh) box.innerHTML = fresh.innerHTML;
            // #CartDrawer is replaced but <cart-drawer> is not, so its own state
            // class has to follow the markup we just put inside it
            host.classList.toggle('is-empty', !!box.querySelector('.drawer__inner-empty'));
          }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sec['cart-icon-bubble']) {
            var t2 = document.createElement('div');
            t2.innerHTML = sec['cart-icon-bubble'];
            var f2 = t2.querySelector('#cart-icon-bubble');
            if (f2) bubble.innerHTML = f2.innerHTML;
          }
        })
        .catch(function () {});
    }

    var pending = null;
    function check() {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        if (busy) return;
        reconcile().then(function (changed) {
          if (changed) repaint().then(function () { cartInit(host); });
        });
      }, 220);
    }

    // The cart page updates its own section, not the drawer, so listen for Dawn's
    // event as well as watching the drawer's markup.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { check(); }); } catch (e) {}
    }

    // Watch <cart-drawer> itself, not #CartDrawer. Dawn's renderContents replaces
    // the inside of #CartDrawer, but quickAdd() replaces the whole element, which
    // would leave an observer bound to #CartDrawer watching a detached node.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        cartInit(host);
        check();
      }).observe(host, { childList: true, subtree: true });
      say('watching the drawer');
    }
    check();
  }

  // Dawn binds the overlay's click in its constructor, on that one element. Every
  // cart render replaces #CartDrawer, the overlay goes with it, and clicking
  // outside silently stops closing the drawer. <cart-drawer> itself is never
  // replaced, so listen there instead and it survives every re-render.
  function drawerOverlay() {
    var host = document.querySelector('cart-drawer');
    if (!host || host.dataset.popOverlayBound) return;
    host.dataset.popOverlayBound = '1';
    host.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.id === 'CartDrawer-Overlay' || (t.classList && t.classList.contains('cart-drawer__overlay'))) {
        if (typeof host.close === 'function') host.close();
      }
    });
  }

  // Re-binds only what lives inside the drawer. init() is too broad to re-run on
  // every cart render.
  function cartInit(scope) {
    if (!scope) return;
    try {
      quickAdd(scope);
      upVariant(scope);
    } catch (e) {}
  }

  function bundlePick(scope) {
    var choose = function (n) {
      var tiers = document.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions)');
      if (!tiers) return false;
      var bars = tiers.querySelectorAll('.kaching-bundles__bar');
      if (!bars.length) return false;
      var re = new RegExp('(^|[^0-9])' + n + '([^0-9]|$)');
      var target = null;
      [].forEach.call(bars, function (b) {
        if (target) return;
        var t = b.querySelector('.kaching-bundles__bar-title');
        if (t && re.test(t.textContent)) target = b;
      });
      if (!target) target = bars[n - 1] || null;
      if (!target) return false;
      if (!target.classList.contains('kaching-bundles__bar--selected')) {
        var lab = target.querySelector('.kaching-bundles__bar-container');
        if (lab) lab.click();
      }
      var block = document.querySelector('.kaching-bundles');
      if (block) {
        try { block.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { block.scrollIntoView(); }
      }
      return true;
    };
    (scope || document).querySelectorAll('[data-pop-bundlepick]').forEach(function (a) {
      if (a.dataset.popBound) return;
      a.dataset.popBound = '1';
      a.addEventListener('click', function (e) {
        var n = parseInt(a.dataset.popBundlepick, 10);
        if (!n || !document.querySelector('.kaching-bundles')) return;
        e.preventDefault();
        choose(n);
      });
    });
    if (document.documentElement.dataset.popPickRan) return;
    var m = /^#pick-(\d+)$/.exec(window.location.hash || '');
    if (!m) return;
    document.documentElement.dataset.popPickRan = '1';
    var tries = 0;
    var go = function () {
      if (choose(parseInt(m[1], 10))) return;
      if (++tries > 70) return;
      window.setTimeout(go, 300);
    };
    go();
  }

  function loopVideos(scope) {
    var cards = (scope || document).querySelectorAll('[data-pop-loop]');
    if (!cards.length) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    cards.forEach(function (card) {
      if (card.dataset.popLoopReady) return;
      card.dataset.popLoopReady = '1';
      var v = card.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disableremoteplayback', '');
      v.removeAttribute('controls');
      v.controls = false;
      if (still) {
        v.autoplay = false;
        v.controls = true;
        v.preload = 'metadata';
        return;
      }
      var wanted = false;
      function attempt() {
        if (!wanted) return;
        var r = v.play();
        if (r && r.catch) r.catch(function () {});
      }
      function arm() {
        if (v.preload !== 'auto') { v.preload = 'auto'; }
        if (v.readyState < 2) {
          v.addEventListener('loadeddata', attempt, { once: true });
          v.addEventListener('canplay', attempt, { once: true });
          if (v.networkState === 0 || v.readyState === 0) v.load();
        }
        attempt();
      }
      v.addEventListener('pause', function () {
        if (wanted && !v.ended && document.visibilityState === 'visible') attempt();
      });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') attempt();
      });
      if (!('IntersectionObserver' in window)) { wanted = true; arm(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { wanted = true; arm(); }
          else { wanted = false; v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.2 });
      io.observe(card);
    });
  }

  function jmSort() {
    if (window.__popJmSort) return;
    window.__popJmSort = 1;

    function build(sel) {
      var wrap = sel.parentElement;
      if (!wrap || !wrap.classList.contains('jm-sort-filter')) return;
      if (wrap.querySelector('.pop-jmsort__btn')) return;

      sel.setAttribute('tabindex', '-1');
      sel.setAttribute('aria-hidden', 'true');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pop-jmsort__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Sort reviews by');
      btn.textContent = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';

      var list = document.createElement('ul');
      list.className = 'pop-jmsort__list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;

      function close() {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        wrap.classList.remove('is-open');
      }
      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        wrap.classList.add('is-open');
      }
      function pick(i) {
        sel.selectedIndex = i;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        btn.textContent = sel.options[i].text;
        Array.prototype.forEach.call(list.children, function (li, n) {
          if (n === i) li.setAttribute('aria-selected', 'true');
          else li.setAttribute('aria-selected', 'false');
        });
        close();
        btn.focus();
      }

      Array.prototype.forEach.call(sel.options, function (o, i) {
        var li = document.createElement('li');
        li.className = 'pop-jmsort__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('tabindex', '-1');
        li.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
        li.textContent = o.text;
        li.addEventListener('click', function () { pick(i); });
        list.appendChild(li);
      });

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (list.hidden) open(); else close();
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
          (list.children[sel.selectedIndex] || list.children[0]).focus();
        }
      });
      list.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(list.children);
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (i >= 0) pick(i); }
        else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
        else if (e.key === 'Tab') { close(); }
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });

      wrap.insertBefore(btn, sel.nextSibling);
      wrap.appendChild(list);
    }

    function scan() {
      document.querySelectorAll('.jdgm-widget .jm-sort-filter__select').forEach(build);
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      scan();
      var w = document.querySelector('.jdgm-widget .jm-sort-filter');
      if (w || tries > 120) {
        clearInterval(timer);
        var root = document.querySelector('.jdgm-widget');
        if (root) new MutationObserver(function () { scan(); }).observe(root, { childList: true, subtree: true });
      }
    }, 500);
  }

  function hashLand() {
    if (window.__popHashLand) return;
    window.__popHashLand = 1;
    var hash = location.hash;
    if (!hash || hash.length < 2) return;
    var el = null;
    try { el = document.querySelector(hash); } catch (e) { return; }
    if (!el) return;
    var free = false;
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) {
      window.addEventListener(ev, function () { free = true; }, { passive: true, once: true });
    });
    var land = function () { if (!free) el.scrollIntoView({ block: 'start' }); };
    land();
    [300, 900, 1800, 3000].forEach(function (ms) { setTimeout(land, ms); });
    window.addEventListener('load', function () { setTimeout(land, 250); });
  }

  function jmWrite() {
    if (window.__popJmWrite) return;
    var star = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.5l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.3l-6 3.3 1.3-6.6L2.4 9.4l6.7-.8z"/></svg>';

    function open() {
      var real = document.querySelector('.jdgm-widget [data-testid="write-review-button"], .jdgm-widget .jm-action-buttons__button');
      if (real) real.click();
    }

    function build(widget) {
      if (widget.querySelector('.pop-jmwrite')) return true;
      if (!widget.querySelector('.jm-action-buttons__button')) return false;
      var card = document.createElement('div');
      card.className = 'pop-jmwrite';
      card.innerHTML =
        '<div class="pop-jmwrite__head">' +
          '<h3 class="pop-jmwrite__title">Tell the next person</h3>' +
          '<p class="pop-jmwrite__sub">A minute of your time helps someone decide whether purple is for them.</p>' +
        '</div>' +
        '<button class="pop-jmwrite__field" type="button" aria-label="Write a review">' +
          '<span class="pop-jmwrite__stars" aria-hidden="true">' + star + star + star + star + star + '</span>' +
          '<span class="pop-jmwrite__ph">How do you drink yours? Latte, smoothie, folded into pandesal...</span>' +
          '<span class="pop-jmwrite__lines" aria-hidden="true"><i></i><i></i><i></i></span>' +
        '</button>' +
        '<div class="pop-jmwrite__foot">' +
          '<p class="pop-jmwrite__note">Photos welcome. Every review is verified by Judge.me.</p>' +
          '<button class="pop-btn pop-btn--purple pop-jmwrite__btn" type="button">Write a review</button>' +
        '</div>';
      card.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', open); });
      var slot = document.createElement('div');
      slot.className = 'pop-jmwrite-slot';
      slot.appendChild(card);
      widget.appendChild(slot);
      return true;
    }

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var w = document.querySelector('.jdgm-widget');
      if ((w && build(w)) || tries > 120) clearInterval(timer);
    }, 500);
    window.__popJmWrite = 1;
  }

  // Community tiles, small screens only. A phone has no hover, so the tiles take
  // their cue from scroll position instead: whichever pair is crossing the middle
  // of the screen straightens out of its tilt, grows and throws a longer shadow,
  // then settles back as it moves on. Driven per frame rather than by a
  // transition so it tracks the finger both ways.
  function comPop(scope) {
    var grid = (scope || document).querySelector('.pop-com__tiles');
    if (!grid || grid.dataset.popPop) return;
    grid.dataset.popPop = '1';

    var tiles = [].slice.call(grid.querySelectorAll('.pop-com__tile'));
    if (!tiles.length) return;
    var small = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

    var queued = false;
    var near = true;

    function clear() {
      tiles.forEach(function (el) {
        el.style.setProperty('--pop', '0');
        el.style.setProperty('--sway', '0');
        el.style.zIndex = '';
      });
    }

    function frame() {
      queued = false;
      if (reduce || !small || !small.matches) { clear(); return; }
      var mid = window.innerHeight * 0.5;
      // How far from the middle a tile still gets some of the effect.
      var reach = window.innerHeight * 0.34;
      for (var i = 0; i < tiles.length; i++) {
        var el = tiles[i];
        var r = el.getBoundingClientRect();
        var off = mid - (r.top + r.height / 2);
        // Signed, -1 below the middle to +1 above it. This is what makes the tile
        // rock one way on the approach and the other way on the way out, instead
        // of doing the same thing in both directions.
        var s = Math.max(-1, Math.min(1, off / reach));
        s = Math.sin(s * Math.PI / 2);
        // Unsigned, peaks at the middle. Drives the bob and the shadow.
        var p = Math.max(0, 1 - Math.abs(off) / reach);
        p = p * p * (3 - 2 * p);
        el.style.setProperty('--sway', s.toFixed(3));
        el.style.setProperty('--pop', p.toFixed(3));
      }
    }

    function onScroll() {
      if (!near || queued) return;
      queued = true;
      requestAnimationFrame(frame);
    }

    // Only measure while the strip is anywhere near the screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        near = entries[0].isIntersecting;
        if (near) frame(); else clear();
      }, { rootMargin: '25% 0px' }).observe(grid);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (small && small.addEventListener) small.addEventListener('change', frame);
    frame();
  }

  // Reviews whose author matches a handle in assets/ubiyam-ig-handles.json get a
  // small Instagram mark beside the name. Nothing else about the row is touched:
  // no avatar, no wording, no rating. The list is a plain data file so handles can
  // be added or removed without editing code, and the match is deliberately loose,
  // because a reviewer name typed by hand will not equal the handle character for
  // character.
  //
  // It finds the name by reading text, not by matching a class. Two earlier versions
  // keyed off Judge.me class names and both found nothing: the widget is a Vue app
  // that renders client side, so the classes cannot be checked from here, and every
  // guess is a silent failure. A text node whose entire contents are a known handle
  // is the name, whatever the element around it happens to be called.
  function jmInstagram() {
    if (window.__popJmIg || !window.fetch) return;
    var src = window.POP_IG_SRC;
    if (!src) return;
    if (window.POP_IG && window.POP_IG.on === false) return;

    // Readable from the console, so a page showing no marks can say why.
    var debug = { src: src, loaded: false, handles: 0, root: null, scanned: 0, walked: 0, matched: 0, error: null };
    window.__popJmIg = debug;

    // Confirmed in a real browser: the name is span.jm-text.jm-reviewer-info__name.
    var NAME_SEL = '.jm-reviewer-info__name, .jdgm-rev__author, [class*="reviewer-info__name"], [class*="reviewer"][class*="name"]';
    // Only used when the class above finds nothing. querySelectorAll, never
    // querySelector: the first match in the document is the write-a-review modal,
    // and walking that instead of the list is what made this look dead twice.
    var ROOT_SEL = '.jdgm-widget, [class*="jdgm-review-widget"], [data-widget-container], [class*="jm-review"], [class*="judgeme"]';

    var map = null;
    var keys = null;

    // Everything that is not a letter or a digit is noise here: the leading @, the
    // dots and underscores inside a handle, stray spaces, capitals.
    function norm(s) {
      return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9]+/g, '');
    }

    // True when a and b differ by at most one insert, delete or substitution.
    // A single pass, rather than a distance matrix, because one edit is the only
    // answer worth having.
    function within1(a, b) {
      if (a === b) return true;
      var la = a.length, lb = b.length;
      if (la - lb > 1 || lb - la > 1) return false;
      var i = 0, j = 0, edits = 0;
      while (i < la && j < lb) {
        if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
        if (++edits > 1) return false;
        if (la > lb) i++;
        else if (lb > la) j++;
        else { i++; j++; }
      }
      return edits + (la - i) + (lb - j) <= 1;
    }

    function lookup(raw) {
      var n = norm(raw);
      if (!n) return null;
      if (Object.prototype.hasOwnProperty.call(map, n)) return map[n];
      // Forgiving a typo is only safe on a name long enough that two different
      // people will not collide by accident, so short handles must match exactly.
      if (n.length < 8) return null;
      for (var i = 0; i < keys.length; i++) {
        if (keys[i].length >= 8 && within1(keys[i], n)) return map[keys[i]];
      }
      return null;
    }

    // Theme settings win, the data file's "_label" is the fallback, and the literal
    // here is the last resort. Everything editable lives in Theme settings under
    // "Instagram review badge".
    var cfg = window.POP_IG || {};
    var label = cfg.label || 'Verified in Instagram';
    var showLink = cfg.link !== false;
    var showAvatar = cfg.avatar !== false;

    // One mark, not three. A glyph, a badge and a separate link button ran to 164px
    // beside a name that is itself long, which is what the user rejected. The whole
    // badge is the link now, and it matches the footprint of the "Verified by Shop"
    // badge sitting on the review above it.
    function mark(url) {
      var link = url && showLink;
      var el = document.createElement(link ? 'a' : 'span');
      el.className = 'pop-jmig__mark';
      if (link) {
        el.href = url;
        el.target = '_blank';
        el.rel = 'noopener nofollow';
        el.title = 'Verified on Instagram, opens the original post';
        el.setAttribute('aria-label', 'Verified on Instagram, opens the original post in a new tab');
      } else {
        el.title = 'Verified on Instagram';
      }
      var glyph = document.createElement('span');
      glyph.className = 'pop-jmig__glyph';
      glyph.setAttribute('aria-hidden', 'true');
      var text = document.createElement('span');
      text.className = 'pop-jmig__label';
      text.textContent = label;
      el.appendChild(glyph);
      el.appendChild(text);
      return el;
    }

    // The grey circle shows "@", which is the first character of every one of these
    // names and so tells the reader nothing. Swap in the first real letter and let
    // CSS paint the circle in the Instagram gradient.
    // Climbs until it finds the ancestor that actually holds an avatar. closest()
    // on a class match is wrong here: the name element is jm-reviewer-info__name,
    // so it matches "reviewer-info" and closest() returns the name itself.
    function avatarHost(nameEl) {
      var e = nameEl.parentElement;
      for (var n = 0; e && n < 6; e = e.parentElement, n++) {
        if (e.querySelector('[class*="avatar"]')) return e;
      }
      return null;
    }

    function avatarInitial(host, handle) {
      if (!showAvatar || !host) return;
      var slot = host.querySelector('.jm-reviewer-avatar__initial .jm-text')
        || host.querySelector('[class*="avatar__initial"] [class*="jm-text"]')
        || host.querySelector('[class*="avatar__initial"]');
      if (!slot) return;
      var m = String(handle).match(/[a-z0-9]/i);
      if (!m) return;
      // Just the first real letter, lower case: exactly what the widget puts in
      // everyone else's circle. The bare "@" it starts with is the one character
      // every handle shares, so it identifies nobody.
      var letter = m[0].toLowerCase();
      // Compared before writing, so Vue putting the "@" back is repaired on the
      // next pass while an unchanged slot never triggers another mutation.
      if (slot.textContent !== letter) slot.textContent = letter;
      var av = host.querySelector('[class*="reviewer-avatar"]');
      if (av && !av.classList.contains('pop-jmig-av')) av.classList.add('pop-jmig-av');
    }

    var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1 };

    // Collected first, applied after. Mutating the tree mid-walk invalidates it.
    function findNames(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var hits = [];
      var node;
      while ((node = walker.nextNode())) {
        var text = node.nodeValue;
        // A reviewer name is short. Anything longer is a review body.
        if (!text || text.length > 64) continue;
        var trimmed = text.replace(/^\s+|\s+$/g, '');
        if (trimmed.length < 3) continue;
        var parent = node.parentNode;
        if (!parent || parent.nodeType !== 1 || SKIP[parent.nodeName]) continue;
        debug.walked++;
        // The whole node has to be the handle. A body that merely mentions a
        // creator must not pick up a mark.
        var url = lookup(trimmed);
        if (url === null) continue;
        hits.push({ node: node, parent: parent, url: url });
      }
      return hits;
    }

    // Presence of the mark is the guard, not a flag. Vue rebuilds the list on every
    // sort and page change and takes our node with it; a flag left on a recycled
    // element would stop it ever coming back.
    function place(parent, after, url) {
      if (parent.querySelector && parent.querySelector('.pop-jmig__mark')) return false;
      parent.insertBefore(mark(url), after ? after.nextSibling : null);
      return true;
    }

    // The name element truncates with an ellipsis, so a pill dropped inside it is
    // clipped out of sight and eats the name's own width on the way. It goes next
    // to the name, in the flex row above it, not in it.
    function placeBeside(nameEl, url, handle) {
      var host = nameEl.parentNode;
      if (!host || host.nodeType !== 1) return false;
      avatarInitial(avatarHost(nameEl), handle);
      // Re-arms the verified-buyer guard in CSS. Scoped to the one review item, not
      // to any ancestor that happens to match, or it would hide the badge on rows
      // that earned it.
      var item = nameEl.closest && nameEl.closest('.jm-review-item');
      if (item) item.classList.add('pop-jmig');
      if (host.querySelector('.pop-jmig__mark')) return false;
      host.insertBefore(mark(url), nameEl.nextSibling);
      return true;
    }

    var queued = false;
    function scan() {
      queued = false;
      if (!map || !keys.length) return;
      var seen = 0, hit = 0, i;

      var els = document.querySelectorAll(NAME_SEL);
      for (i = 0; i < els.length; i++) {
        seen++;
        var raw = els[i].textContent;
        var url = lookup(raw);
        if (url !== null && placeBeside(els[i], url, raw)) hit++;
      }

      if (!els.length) {
        var roots = document.querySelectorAll(ROOT_SEL);
        for (i = 0; i < roots.length; i++) {
          var hits = findNames(roots[i]);
          seen += debug.walked;
          for (var j = 0; j < hits.length; j++) {
            if (place(hits[j].parent, hits[j].node, hits[j].url)) hit++;
          }
        }
        debug.root = roots.length;
      }

      debug.scanned = seen;
      debug.matched = hit;
    }
    function kick() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(scan);
    }

    function parse(data) {
      var raw = (data && (data.reviewers || data.handles)) || data || {};
      var out = {};
      var i;
      if (Object.prototype.toString.call(raw) === '[object Array]') {
        for (i = 0; i < raw.length; i++) {
          var v = raw[i];
          if (typeof v === 'string') out[norm(v)] = '';
          else if (v && v.handle) out[norm(v.handle)] = v.url || v.permalink || '';
        }
      } else {
        for (var k in raw) {
          // Keys starting with an underscore are notes for whoever edits the file.
          if (!Object.prototype.hasOwnProperty.call(raw, k) || k.charAt(0) === '_') continue;
          var m = raw[k];
          out[norm(k)] = typeof m === 'string' ? m : (m && (m.url || m.permalink)) || '';
        }
      }
      delete out[''];
      return out;
    }

    fetch(src, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!cfg.label && data && typeof data._label === 'string' && data._label) label = data._label;
        map = parse(data);
        // Handles typed into Theme settings, one per line, "handle | url".
        if (typeof cfg.extra === 'string' && cfg.extra) {
          var lines = cfg.extra.split(/[\r\n]+/);
          for (var n = 0; n < lines.length; n++) {
            var bits = lines[n].split('|');
            var h = norm(bits[0]);
            if (h) map[h] = (bits[1] || '').replace(/^\s+|\s+$/g, '');
          }
        }
        keys = Object.keys(map);
        debug.loaded = true;
        debug.handles = keys.length;
        kick();
      })
      .catch(function (e) {
        map = {};
        keys = [];
        debug.error = String(e);
      });

    new MutationObserver(kick).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init(scope) { marquee(scope); reveal(scope); warmImages(scope); flips(scope); accordions(scope); story(); articleLayout(); hoverMenus(); galleries(scope); stickyAtc(scope); sortSelects(scope); shareButtons(scope); sharePopup(scope); popLoc(scope); policyLinks(scope); videoCards(scope); vidCarousel(scope); revCarousel(scope); pvidCarousel(scope); urgency(scope); viewers(scope); popDates(scope); bundleSavings(); quickAdd(scope); upVariant(scope); bundlePick(scope); loopVideos(scope); ritual(scope); locSelects(scope); comPop(scope); jmWrite(); jmSort(); hashLand(); }

  // Started on its own rather than from init(). It is observer driven, so it needs
  // no per-section re-run, and inside init() a throw in any of the two dozen calls
  // ahead of it would stop it silently.
  try { jmInstagram(); } catch (e) {}

  // Anything carrying data-pop-klform opens that Klaviyo popup instead of following
  // its href. Bound once on the document so it survives every re-render, and left
  // as a real link underneath so it still goes somewhere without JS.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-pop-klform]') : null;
    if (!t) return;
    var id = t.getAttribute('data-pop-klform');
    if (!id) return;
    window._klOnsite = window._klOnsite || [];
    // If Klaviyo never loaded, let the link do its job rather than swallowing the click.
    if (!window.klaviyo && !window._klOnsite.push) return;
    e.preventDefault();
    window._klOnsite.push(['openForm', id]);
  });

  // Same reasoning: the gift rules are money, so they must not depend on two dozen
  // unrelated calls in init() all having survived.
  function startGifts() {
    try { drawerOverlay(); } catch (e) {}
    try { giftRules(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startGifts);
  else startGifts();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); topbar.init(); });
  } else {
    init();
    topbar.init();
  }
  window.addEventListener('load', function () { marquee(); });
  // Safety net
  setTimeout(function () { document.querySelectorAll('.pop-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 3500);

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); topbar.init(); });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('.pop-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
